import { ProductProps } from '../components/ui/ProductCard';
import { Category } from '../types/category';

// Sample product data
export const mockProducts: ProductProps[] = [
  {
    id: '1',
    name: 'Elite Fishing Rod Stand',
    productCode: 'EFS-101',
    image: 'https://images.unsplash.com/photo-1608030919232-bd3e4b12f5a9?q=80&w=600&auto=format',
    description: 'Professional-grade adjustable rod stand with anti-slip feet and weatherproof construction.',
    price: 2699.99,
    specs: [
      { label: 'Material', value: 'Aluminum Alloy' },
      { label: 'Height', value: '0.5-1.2m (adjustable)' },
      { label: 'Weight Capacity', value: '15kg' },
      { label: 'Weight', value: '1.8kg' },
      { label: 'Weather Resistance', value: 'IP65' }
    ],
    categoryIds: ['stands']
  },
  {
    id: '2',
    name: 'Compact Travel Rod Stand',
    productCode: 'CTS-202',
    image: 'https://images.unsplash.com/photo-1542648292-7432b8249bd4?q=80&w=600&auto=format',
    description: 'Lightweight and foldable fishing rod stand, perfect for travel and outdoor expeditions.',
    price: 1599.95,
    specs: [
      { label: 'Material', value: 'Carbon Fiber & Aluminum' },
      { label: 'Height', value: '0.3-0.9m (adjustable)' },
      { label: 'Weight Capacity', value: '8kg' },
      { label: 'Folded Size', value: '25cm x 10cm' },
      { label: 'Weight', value: '0.9kg' }
    ],
    categoryIds: ['stands']
  },
  {
    id: '3',
    name: 'Heavy-Duty Multi-Rod Holder',
    productCode: 'HDM-303',
    image: 'https://images.unsplash.com/photo-1588539543889-7492b5de0276?q=80&w=600&auto=format',
    description: 'Robust stand capable of holding up to 5 fishing rods simultaneously with independent angle adjustments.',
    price: 4499.99,
    specs: [
      { label: 'Material', value: 'Stainless Steel' },
      { label: 'Rod Capacity', value: '5 rods' },
      { label: 'Height', value: '0.7-1.5m (adjustable)' },
      { label: 'Weight Capacity', value: '30kg' },
      { label: 'Weight', value: '3.2kg' }
    ],
    categoryIds: ['holders']
  },
  {
    id: '4',
    name: 'Precision Bank Stick',
    productCode: 'PBS-404',
    image: 'https://images.unsplash.com/photo-1604375825310-fb0ca6c12509?q=80&w=600&auto=format',
    description: 'Specialized single rod holder with precise angle adjustment and deep ground penetration for stability.',
    price: 1089.99,
    specs: [
      { label: 'Material', value: 'Hardened Steel' },
      { label: 'Length', value: '0.4-0.8m (adjustable)' },
      { label: 'Weight Capacity', value: '12kg' },
      { label: 'Angle Adjustment', value: '180°' },
      { label: 'Weight', value: '0.7kg' }
    ],
    categoryIds: ['holders']
  },
  {
    id: '5',
    name: 'Deluxe Illuminated Rod Stand',
    productCode: 'DLS-505',
    image: 'https://images.unsplash.com/photo-1563417774648-7fa1684cd2d7?q=80&w=600&auto=format',
    description: 'Premium rod stand with integrated LED indicators and bite alarms for night fishing.',
    price: 3249.95,
    specs: [
      { label: 'Material', value: 'Aircraft Aluminum' },
      { label: 'Height', value: '0.6-1.3m (adjustable)' },
      { label: 'Power Source', value: 'AA Batteries' },
      { label: 'LED Colors', value: 'Red, Green, Blue' },
      { label: 'Weight', value: '2.1kg' }
    ],
    categoryIds: ['stands', 'accessories']
  },
  {
    id: '6',
    name: 'Boat Fishing Rod Holder',
    productCode: 'BFR-606',
    image: 'https://images.unsplash.com/photo-1464038008305-ee8def74f5b5?q=80&w=600&auto=format',
    description: 'Secure mounting rod holder designed specifically for boats and kayaks with quick-release mechanism.',
    price: 2149.99,
    specs: [
      { label: 'Material', value: 'Marine-grade Stainless Steel' },
      { label: 'Mount Type', value: 'Rail or Surface' },
      { label: 'Rod Angle', value: 'Adjustable 0-45°' },
      { label: 'Corrosion Resistance', value: 'Saltwater Rated' },
      { label: 'Compatibility', value: 'All rod types' }
    ],
    categoryIds: ['holders']
  }
];

// Mock categories data
export const mockCategories: Category[] = [
  { id: 'all', name: 'All Products' },
  { id: 'stands', name: 'Rod Stands' },
  { id: 'holders', name: 'Rod Holders' },
  { id: 'accessories', name: 'Accessories' }
];

// Mock API response function for products
export const getMockProductsResponse = () => {
  return {
    data: mockProducts,
    status: 200,
    statusText: 'OK'
  };
};

// Mock API response function for categories
export const getMockCategoriesResponse = () => {
  return {
    data: mockCategories,
    status: 200,
    statusText: 'OK'
  };
}; 